module.exports = __webpack_public_path__ + "img/微信图片_20210606190140.675180be.png";